"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOfferCreateContextInit = useOfferCreateContextInit;
const moment_1 = __importDefault(require("moment"));
const react_redux_1 = require("react-redux");
const types_1 = require("@src/types");
const use_offer_api_1 = require("@src/components/pages/admin/modules/offer-create-or-edit/use-offer-api");
function useOfferCreateContextInit({ setOfferPaymentTypeInitialValues, setOfferPaymentType, setOfferBasicInfoInitialValues, setOfferBasicInfo, setOfferAssetsInitialValues, setOfferAssets, setHasOfferScrapingFailed, }) {
    // @ts-ignore
    const companyAddress = (0, react_redux_1.useSelector)(state => state.admin.company.address);
    const defaultOfferBasicInfoInitialValues = {
        [types_1.EOfferBasicInfoFormField.salaryCurrency]: '€',
        [types_1.EOfferBasicInfoFormField.resumeRequired]: true,
        [types_1.EOfferBasicInfoFormField.deadline]: (0, moment_1.default)().add(31, 'days').endOf('day'),
        [types_1.EOfferBasicInfoFormField.address]: {
            country: companyAddress === null || companyAddress === void 0 ? void 0 : companyAddress.country,
            formatted_address: companyAddress === null || companyAddress === void 0 ? void 0 : companyAddress.formattedAddress,
            google_place_id: companyAddress === null || companyAddress === void 0 ? void 0 : companyAddress.googlePlaceId,
        },
        [types_1.EOfferBasicInfoFormField.timezone]: companyAddress === null || companyAddress === void 0 ? void 0 : companyAddress.timezone,
    };
    const { fetchDraftOfferValues } = (0, use_offer_api_1.useOfferApi)();
    const fetchOfferInitialValuesForCreate = async ({ draftSlug, }) => {
        if (draftSlug) {
            const draftOfferValues = await fetchDraftOfferValues(draftSlug);
            return {
                offerBasicInfo: (draftOfferValues === null || draftOfferValues === void 0 ? void 0 : draftOfferValues.offerBasicInfo) || defaultOfferBasicInfoInitialValues,
                offerAssets: (draftOfferValues === null || draftOfferValues === void 0 ? void 0 : draftOfferValues.offerAssets) || {},
                offerPaymentType: (draftOfferValues === null || draftOfferValues === void 0 ? void 0 : draftOfferValues.offerPaymentType) || {},
                hasScrapingFailed: false,
            };
        }
        // if (scrapingLink) {
        // 	try {
        // 		const scrapedOfferBasicInfoValues = await fetchScrapedOfferBasicInfo(scrapingLink)
        // 		return {
        // 			offerBasicInfo: scrapedOfferBasicInfoValues,
        // 			offerAssets: {},
        // 			offerPaymentType: {
        // 				[EOfferPaymentTypeFormField.paymentType]: OfferPaymentType.PAY_WITH_OFFER_CREDITS,
        // 			},
        // 			hasScrapingFailed: false,
        // 		}
        // 	} catch {
        // 		return {
        // 			offerBasicInfo: defaultOfferBasicInfoInitialValues,
        // 			offerAssets: {},
        // 			offerPaymentType: {
        // 				[EOfferPaymentTypeFormField.paymentType]: OfferPaymentType.PAY_WITH_OFFER_CREDITS,
        // 			},
        // 			hasScrapingFailed: true,
        // 		}
        // 	}
        // }
        return {
            offerBasicInfo: defaultOfferBasicInfoInitialValues,
            offerAssets: {},
            offerPaymentType: {
                [types_1.EOfferPaymentTypeFormField.paymentType]: types_1.OfferPaymentType.PAY_WITH_OFFER_CREDITS,
            },
            hasScrapingFailed: false,
        };
    };
    const initializeOfferContextForCreate = async ({ draftSlug, }) => {
        const { offerBasicInfo: fetchedOfferBasicInfoInitialValues, offerAssets: fetchedOfferAssetsInitialValues, offerPaymentType: fetchedOfferPaymentTypeInitialValues, hasScrapingFailed, } = await fetchOfferInitialValuesForCreate({ draftSlug });
        setOfferPaymentTypeInitialValues(fetchedOfferPaymentTypeInitialValues);
        setOfferPaymentType(fetchedOfferPaymentTypeInitialValues);
        setOfferBasicInfoInitialValues(fetchedOfferBasicInfoInitialValues);
        setOfferBasicInfo(fetchedOfferBasicInfoInitialValues);
        setOfferAssetsInitialValues(fetchedOfferAssetsInitialValues);
        setOfferAssets(fetchedOfferAssetsInitialValues);
        setHasOfferScrapingFailed(hasScrapingFailed);
    };
    return { initializeOfferContextForCreate };
}
